import { render, staticRenderFns } from "./AdvisorList.vue?vue&type=template&id=6bcf4d3e&"
import script from "./AdvisorList.vue?vue&type=script&lang=js&"
export * from "./AdvisorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports